import http from "../../helpers/http";

import {
    FETCH_MISSION_CONTENT,
    FETCH_MISSION_CONTENT_SUCCESS,
    FETCH_MISSION_CONTENT_FAILED
} from "./actionTypes";

export const fetchMission = () => (dispatch) => {
    dispatch({
        type: FETCH_MISSION_CONTENT,
        payload: null
    });
    http
        .get("mission-page")
        .then(({ data }) => {
            dispatch({
                type: FETCH_MISSION_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_MISSION_CONTENT_FAILED,
                payload: error
            });
        });
};
